import axios from "axios";

export const requestWithdraw = async ({ userId, socket, userPayload } = {}) => {
  if (!userId) {
    return {
      success: false,
      message: "กรุณาเข้าสู่ระบบก่อน",
      raw: null,
    };
  }

  try {
    const body = new URLSearchParams();
    body.append("message", "withdraw request");
    body.append("requestSource", "GENERAL");
    body.append("requestChannel", "FRONTEND");

    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/8hwe8vhevv/requestwithdraw/${userId}`,
      body,
    );

    const isSuccess = response?.data?.success === true;

    return {
      success: isSuccess,
      message: isSuccess
        ? "แจ้งถอนเงินเรียบร้อย กรุณารอการอนุมัติจากเจ้าหน้าที่"
        : response?.data?.message ||
          "กรุณาทำยอดให้ครบตามเงื่อนไขหรือเคลียร์เดิมพันคงค้าง",
      raw: response?.data,
    };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error?.response?.data?.error?.message ||
        "ไม่สามารถแจ้งถอนเงินได้ โปรดติดต่อเจ้าหน้าที่",
      raw: error,
    };
  }
};
